import React from 'react';
import { Header } from '../components';
import * as ROUTES from '../constants/routes';
import logo from '../logo.svg';

export function HeaderContainer({ children, showLogo = true, showSignInButton = true, headerStyle }) {
  return (
    <Header style={headerStyle}>
      <Header.Frame>
        {showLogo && <Header.Logo to={ROUTES.HOME} src={logo} alt="vieon" />}
        {showSignInButton && <Header.ButtonLink to={ROUTES.SIGN_IN}>Đăng nhập</Header.ButtonLink>}
      </Header.Frame>
      {children}
    </Header>
  );
}
